import { createSelector } from 'reselect'
import { IDifferentActivitiesRecord } from './interface'

export const getDifferentActivities = (state: any): IDifferentActivitiesRecord => state.get('differentActivities')

export const getDifferentActivitiesPending = createSelector(getDifferentActivities, differentActivities =>
  differentActivities.get('pending')
)

export const getUpcomingActivitiesLoadStatus = createSelector(getDifferentActivities, differentActivities =>
  differentActivities.getIn(['loaded', 'upcoming'])
)

export const getPreviousActivitiesLoadStatus = createSelector(getDifferentActivities, differentActivities =>
  differentActivities.getIn(['loaded', 'previous'])
)

export const getUpcomingActivities = createSelector(getDifferentActivities, differentActivities =>
  differentActivities.get('upcoming')
)

export const getPreviousActivities = createSelector(getDifferentActivities, differentActivities =>
  differentActivities.get('previous')
)
